// extracted by mini-css-extract-plugin
module.exports = {"overlayConfirmation":"ConfirmationModal_overlayConfirmation__3-yHk"};